import React, { useState } from "react";
import styles from "./ContactForm.module.css";

function ContactForm() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <div className={styles.formCard}>
            <form onSubmit={handleSubmit}>

                {/* Name and Email row */}
                <div className={styles.row}>
                    <div className={styles.fieldGroup}>
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Edward"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className={styles.fieldGroup}>
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Edwarda.me@gmail.com"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Phone number */}
                <div className={styles.fieldGroup}>
                    <label htmlFor="phone">Phone number</label>
                    <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Enter your Phone number"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </div>

                {/* Message */}
                <div className={styles.fieldGroup}>
                    <label htmlFor="message">Leave us a message</label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="Tell us more..."
                        value={formData.message}
                        onChange={handleChange}
                        rows={5}
                    />
                </div>

                <button type="submit" className={styles.submitBtn}>
                    Send Message
                </button>

            </form>
        </div>
    );
}

export default ContactForm;